import { render, staticRenderFns } from "./MetricForm.vue?vue&type=template&id=774646a6"
import script from "./MetricForm.vue?vue&type=script&lang=js"
export * from "./MetricForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports